module.exports = __webpack_public_path__ + "img/sticker_produced.3ef48b95.png";